import { Dispatch } from 'react';
import { TMaintenancePackageActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_MAINTENANCE_PACKAGES } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { IFiltersMaintenancePackages } from 'src/components/MaintenancePackages/Filters/components/types';
import { ApiV2 } from 'src/api/apiv2';
import { TAPIOptions } from 'src/constants/apis/types';

export const searchMaintenancePackagesByFilters = async (
    dispatch: Dispatch<TMaintenancePackageActionTypes>,
    values: Omit<IFiltersMaintenancePackages, 'createdAt'>,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await ApiV2.post(
            '/maintenance-packages/search',
            values,
            HEADERS({
                isReadPermissionNecessary:
                    options.isReadPermissionNecessary || false,
            })
        );

        dispatch({
            type: GET_MAINTENANCE_PACKAGES,
            payload: res.data.results,
            total: res.data.pagination.total || 0,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
